export const sleep = (time: number) =>
    new Promise((res) => setTimeout(res, time));

export const splitByUpperCase = (text: string) => {
    return text.replace(/([A-Z])/g, ' $1').trim();
};

export const formatToTwoDecimalPlaces = (value: any): string => {
    if (value === null || value === undefined || isNaN(value)) {
        return '-';
    }

    const num = Number(value);
    const [intPart, decPart] = num.toFixed(2).split('.');

    const paddedInt = intPart.padStart(2, '0');

    return `${paddedInt}.${decPart}`;
};
